import _regeneratorRuntime from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// 获取设置接口
import { getdepartmentvisit as _getdepartmentvisit, setdepartmentvisit as _setdepartmentvisit, getdepartmentvisitcolumn } from 'api/settings';
export default {
  data: function data() {
    return {
      checked: false,
      isEdit: false,
      loading: false,
      radio: '3',
      radio1: '5',
      checkList: [],
      departmentColumn: {}
    };
  },
  created: function created() {
    this.getdepartmentvisit();
    this.getDepartment();
  },
  methods: {
    // 开启编辑状态
    changeEdit: function changeEdit(v) {
      this.isEdit = v;
    },
    getDepartment: function getDepartment() {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var res;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return getdepartmentvisitcolumn();
            case 2:
              res = _context.sent;
              if (res.code === 1) {
                _this.departmentColumn = res.data.column;
              }
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    // 获取信息
    getdepartmentvisit: function getdepartmentvisit() {
      var _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var res, _res$data, type, column;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _this2.loading = true;
              _context2.next = 3;
              return _getdepartmentvisit();
            case 3:
              res = _context2.sent;
              _res$data = res.data, type = _res$data.type, column = _res$data.column;
              _this2.radio = type;
              _this2.checkList = column;
              if (type === '31') {
                _this2.radio = '3';
                _this2.checked = true;
              }
              _this2.loading = false;
            case 9:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    // 保存
    setdepartmentvisit: function setdepartmentvisit() {
      var _this3 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var type;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              // 逻辑同上
              // checkebox 必须在radio等于3才可以选中
              // chekebox 选中则type为31
              type = _this3.checked ? '31' : _this3.radio;
              _context3.next = 3;
              return _setdepartmentvisit({
                type: type,
                column: _this3.checkList
              });
            case 3:
              _this3.changeEdit(false);
            case 4:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    // 取消
    handlerCancel: function handlerCancel() {
      this.getdepartmentvisit();
      this.changeEdit(false);
    },
    // radio不等于3 则不能选中checkebox
    handlerChange: function handlerChange() {
      this.checkList = ['1', '2', '3', '4', '5'];
      if (this.radio !== '3') this.checked = false;
    }
  }
};